import { createRoot } from 'react-dom/client';

// third party
import { Provider } from 'react-redux';

// project imports
import { store } from './store';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);